import {svgIconWrapper} from '../svg-icon-wrapper';

import ExternalArrowRegular from './external-arrow-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ExternalArrowRegular {...validProps} />;
}

SvgComponent.iconName = 'externalArrowRegular';

export const ExternalArrowRegularIcon = svgIconWrapper(SvgComponent);
